module.exports = __webpack_public_path__ + "img/2017-01-1024x768.deb7dca0.jpg";